export default __webpack_public_path__ + "static/media/swissotel-sydney-australia-slider.46819217.jpg";